
import React from 'react';

import Goonj2024 from 'views/Goonj2024/Goonj2024';

const SchoolProgrampage = () => {
  return <Goonj2024 />;
};

export default SchoolProgrampage;